import React from 'react'
import { ToastNotification } from 'components/Zui'
import { ewiIcons } from 'app/constants'
import 'react-toastify/dist/ReactToastify.css'
import './index.css'

const index = ({ text, description, icon = 'info', onClose }) => {
    return (
        <ToastNotification state="default" closable onClose={onClose}>
            <span slot="headerText">{text}</span>
            {description && <span>{description}</span>}

            {ewiIcons[icon]}
        </ToastNotification>
    )
}

export default index
